import verifyEmailModule from "../verifyEmailModule"
import { UrlParser } from "Roblox";
import { urlService } from 'core-utilities';

function verifyEmailController($scope, $window, verifyEmailResources, urlService, verifyEmailService) {
    "ngInject";

    $scope.isEmailVerified = false;

    //putting this to own function so that it's easier to unit test without having to redirect the page.
    $scope.redirect = function redirect(url) {
        $window.location.href = urlService.getAbsoluteUrl(url);
    };

    function handleRedirect(url) {
        $scope.redirect(url);
    }

    function init() {
    
        var ticket = UrlParser && UrlParser.getParameterValueByName(verifyEmailResources.paramNames.ticket, false);
        if (!ticket) {
            handleRedirect(verifyEmailResources.urls.home);
        }
        var params = {
            ticket: ticket
        };

        verifyEmailService.verifyEmail(params).then(function (response) {
            $scope.isEmailVerified = true;
            $scope.buttonHref = verifyEmailResources.urls.catalog + response.data.verifiedUserHatAssetId;
        }).catch(function (data) {
            // if verification failed, redirect to home page. 
            handleRedirect(verifyEmailResources.urls.home);
        });
    };

    init();
};

verifyEmailModule.controller("verifyEmailController", verifyEmailController);

export default verifyEmailController;